import React from "react";

export default function CargoAnularModal({ open, cargo, deleting, onClose, onConfirm }) {
  if (!open) return null;

  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <div>
              <p className="management-eyebrow mb-1 text-danger">Anular cargo</p>
              <h5 className="modal-title mb-0 d-flex align-items-center gap-2">
                <i className="bi bi-exclamation-triangle" /> Confirmar acción
              </h5>
            </div>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <p className="mb-2">
              ¿Estás seguro de que deseas anular el cargo{" "}
              <strong>{cargo?.concepto_nombre}</strong>
              {cargo?.estudiante_nombre ? (
                <> de <strong>{cargo.estudiante_nombre}</strong></>
              ) : null}?
            </p>
            <p className="text-muted mb-0">
              Esta acción no se puede deshacer. El cargo quedará registrado como anulado.
            </p>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={deleting}>
              Cancelar
            </button>
            <button type="button" className="btn btn-danger text-white" onClick={onConfirm} disabled={deleting}>
              {deleting ? (
                <><span className="spinner-border spinner-border-sm me-2" />Anulando...</>
              ) : (
                <><i className="bi bi-trash me-2" />Anular cargo</>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
